<template>
<div>
    <h2>{{ $t("homeView.instructions")}}</h2>
    <p v-for="(paragraph, i) in store.globalSettings.publicRulesDescription ? store.globalSettings.publicRulesDescription.split('\n') : ''" class="about" :key="i">
        {{ paragraph }}<br>
    </p>
</div>
</template>

<script lang="ts">
import { store } from "store";
import { defineComponent } from "vue";

export default defineComponent({
    mounted() {
        this.setTitle();
    },
    data() {
        return {
            store: store
        };
    },
    methods: {
        setTitle() {
            store.page.title = this.$t("homeView.instructions") as string;
            store.page.showTopNav = true;
        }
    }
})

</script>